
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/ARK",
      function () {
        return require("private-next-pages/money-fortune/ARK.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/ARK"])
      });
    }
  